<template>
  <div class="flex flex-col gap-3">
    <div v-for="filter in visibleFormats" :key="filter.key" class="flex items-center gap-1">
      <LazyFrontendServiceFilterToggleableToggle
        v-if="toggleable"
        :filter-id="filter.filterId"
        :aria-label="`Toggle ${filter.label}`"
      />
      <UCheckbox
        v-model="filter.selected"
        :label="filter.label"
        :ui="{ label: 'font-light' }"
        :aria-label="`Checkbox for ${filter.label}`"
      >
        <template #label>
          <div class="flex items-center gap-x-2">
            {{ filter.label }}
            <HTooltip
              v-if="filter.toolTipContent"
              :text="filter.toolTipContent"
              :ui="{ position: 'right', width: 'max-w-3xl', base: 'text-wrap h-fit' }"
            >
              <UIcon name="heroicons:information-circle" :aria-label="`Information about ${filter.label}`" />
            </HTooltip>
          </div>
        </template>
      </UCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { generateServiceFilterDeliveryFormatsObjects } from '~/utils/serviceSearch/types/ServiceFilterDeliveryFormats'

const props = defineProps({
  toggleable: Boolean
})

const deliveryFormats = reactive(generateServiceFilterDeliveryFormatsObjects())

const store = useServiceSearchStore()
const { filters, disabledFilters } = storeToRefs(store)

// Filter out the formats that are disabled in Iframe settings
const visibleFormats = computed(() => {
  const formatsArray = Object.values(deliveryFormats)
  if (props.toggleable) return formatsArray
  const disabled = disabledFilters.value || []
  return formatsArray.filter((x) => {
    if (x.frontEndHidden) return false
    return !disabled.includes(x.filterId)
  })
})

onMounted(() => {
  const storeDeliveryFormats = filters.value.deliveryFormats
  for (const format of storeDeliveryFormats) {
    if (deliveryFormats[format]) {
      deliveryFormats[format].selected = true
    }
  }
})

// watch the delivery formats and update the store when they change
watch(
  deliveryFormats,
  (newDeliveryFormats) => {
    const selectedDeliveryFormats = Object.values(newDeliveryFormats)
      .filter((format) => format.selected)
      .map((format) => format.key)
    filters.value.deliveryFormats = selectedDeliveryFormats
    store.search({ refresh: true })
  },
  { deep: true }
)

// watch the store and update the local when they change, if they differ
watch(
  () => filters.value.deliveryFormats,
  (newDeliveryFormats) => {
    for (const format of Object.values(deliveryFormats)) {
      format.selected = newDeliveryFormats.includes(format.key)
    }
  }
)
</script>
